/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import { AlertDialog, Field, Input } from '@components/design-system';
import * as Styles from '@components/modals/styles';
import { ILooseObject } from '@interface/loose-object';
import { burn } from '@lib/beacon';
import { RootState } from '@state/store';

export interface ITokenBurn {
  open?: boolean;
  onOpenChange?: (value: boolean) => void;
  platformName?: string;
  tokenKT?: string;
  tokenId?: number;
  tokensOwned?: number;
}

export const TokenBurn: FC<ITokenBurn> = ({ open, onOpenChange, platformName, tokenKT, tokenId, tokensOwned }) => {
  const { account } = useSelector((state: RootState) => state.auth);

  const [values, setValues] = useState<ILooseObject>({
    quantity: { error: false, data: tokensOwned && tokensOwned > 1 ? null : tokensOwned },
  });

  const handleChange = (key: string, value: any) => {
    setValues((prevValues) => ({
      ...prevValues,
      [key]: { error: false, data: value },
    }));
  };

  const setError = (key: string, message: string) => {
    setValues((prevValues) => ({
      ...prevValues,
      [key]: { error: message, data: prevValues[key].data },
    }));
  };

  const validate = () => {
    let valid = true;

    if (!values.quantity.data) {
      setError('quantity', '"Quantity" is missing');
      valid = false;
    }

    if (Math.round(values.quantity.data) > Number(tokensOwned)) {
      setError('quantity', `You only own ${tokensOwned} tokens`);
      valid = false;
    }

    if (Math.round(values.quantity.data) < 1) {
      setError('quantity', 'Minimum quantity 1 tokens');
      valid = false;
    }

    return valid;
  };

  const handleConfirm = () => {
    if (validate() && account && platformName && tokenKT && tokenId) {
      burn(account.address, Number(values.quantity.data), platformName, tokenKT, tokenId);

      if (onOpenChange) {
        onOpenChange(false);
      }
    }
  };

  const handleCancel = () => {
    if (onOpenChange) {
      onOpenChange(false);
    }
  };

  return (
    <AlertDialog
      title="Burn Token"
      description="You're about to burn this token."
      open={open}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
    >
      <Styles.Content>
        {tokensOwned && tokensOwned > 1 && (
          <Field
            uid="quantity"
            label="Quantity"
            tooltip="How many editions are you transfering"
            error={values.quantity.error}
          >
            <Input
              type="number"
              placeholder="e.g.: 1"
              min={1}
              max={tokensOwned}
              value={values.quantity.data || ''}
              onChange={(value: string) => handleChange('quantity', value)}
            />
          </Field>
        )}
      </Styles.Content>
    </AlertDialog>
  );
};
